import { getEndpointUrl } from "../utils/endPoints";
import { handleRequest } from "../utils/httpRequest";
import generalController from "./generalController";

// Get model data based on modelCode and modelOption.
export const fetchModelData = async (modelCode, modelOption) => {
  try {
    const province = generalController.getMetatagValue('province');
    const langCode = generalController.detectLanguage();

    const res = await handleRequest('get',
      `${getEndpointUrl('model-search')}/${modelCode}/${modelOption}?lang_code=${langCode}&prov_code=${province}`);

    if (res.status === 200 && res.data) {
      const vehicleData = res.data;
      const { model_year, carline, financial, year, visual } = vehicleData;

      const vehicleDataFormatted = {
        id: model_year.id,
        isEV: model_year.is_ev,
        title: carline.title,
        slug: carline.url_slug,
        model: carline.voi_leads_name,
        msrp: financial.msrp,
        year: year.url_slug,
        description: model_year.description,
        visual: {
          ...visual,
          jelly: model_year.jelly,
          jelly_hover: model_year.jelly_hover,
          jelly_path: model_year.jelly_path,
        }
      }

      console.log(vehicleDataFormatted);

      return vehicleDataFormatted;
    }

    return false;
  } catch (err) {
    console.log('Error ', err)
  }
}

// Get dealer data based on dealer id.
export const fetchDealerData = async (dealerId) => {
  try {
    const res = await handleRequest('get', `${getEndpointUrl('get-dealer')}/${dealerId}`);

    if (res.status === 200 && res.data) {
      const dealerData = res.data;

      return {
        dealer: dealerData,
        userPosition: {
          lat: dealerData.geolocation?.latitude,
          lng: dealerData.geolocation?.longitude,
        }
      }
    }

    return false;
  } catch (err) {
    console.error('Error ', err)
  }
}